import { AnyAction } from 'redux';
import { StationsState } from '../../types';

import { stationsActions } from '../reducer';

export const updateRouteStationsWithPrices = (value: StationsState['routesStationsWithPrices']['data']): AnyAction =>
  stationsActions.setRouteStationsWithPrices(value);
